import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SelectionModel } from '@angular/cdk/collections';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { AdminRequestDto, AdminResponseDto, AdminService, DeliveryOutputDto, DeliveryPayingInputDto, DeliveryPayingService, DeliveryService, OrderService } from 'src/generated_client';
import { ParticularOrderService } from 'src/generated_client/api/particular-order.service';
import { ParticularOrderDto } from 'src/generated_client/model/particularOrderDto';
import { ParticularOrderForDeliveryPayingDto, ParticularOrderForPayingDto } from 'src/generated_client/model/particularOrderForDeliveryPayingDto';

@Component({
  selector: 'app-liquidaciones-particular-orders',
  templateUrl: './liquidaciones-particular-orders.component.html',
  styleUrls: ['./liquidaciones-particular-orders.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class LiquidacionesParticularOrdersComponent implements OnInit {

  displayedColumns: string[] = ['select', 'cdOrder', 'dtCreatedAt', 'dsName', 'calculatedCost', 'finalCost', 'finalCostWithIVA', 'qtComisionCadete'];
  selection = new SelectionModel<ParticularOrderForPayingDto>(true, []);
  @ViewChild(MatTable) table!: MatTable<ParticularOrderForPayingDto>;
  dataSource = new MatTableDataSource<ParticularOrderForPayingDto>([]);
  selectedOrders: ParticularOrderForPayingDto[] = [];
  allDeliveries: DeliveryOutputDto[] = [];
  dateFrom: any;
  dateTo: any;
  totalDelivery: number = 0;
  totalCommission: number = 0;
  totalLiq: number = 0;
  totalReceipts: number = 0;
  deliveryPayingInput: DeliveryPayingInputDto = {};
  observaciones: string = '';
  ordersList: number[] = [];
  neto: number = 0;
  password: string = '';
  currentUser: AdminResponseDto = {};

  cadetesForm: FormGroup = this.fb.group({
    cadete: ['', Validators.required],
    number: [''],
  })

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows && numRows > 0;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
    
    this.updateSelectedOrders();
  }

  /** Toggle a single row selection */
  toggle(row: ParticularOrderForPayingDto) {
    this.selection.toggle(row);
    this.updateSelectedOrders();
  }

  /** Update the selectedOrders array based on current selection */
  private updateSelectedOrders() {
    this.selectedOrders = this.selection.selected;
    this.recalculateTotals();
  }

  /** Recalcula los totales basados en las órdenes seleccionadas o todas las órdenes si no hay selección */
  private recalculateTotals() {
    this.totalDelivery = 0;
    this.totalCommission = 0;
    this.totalLiq = 0;
    this.neto = 0;
    
    // Usar órdenes seleccionadas si hay alguna, de lo contrario usar todas las órdenes
    const ordersToCalculate = this.selection.selected.length > 0 
      ? this.selection.selected 
      : this.dataSource.data;
    
    this.totalReceipts = ordersToCalculate.length;

    ordersToCalculate.forEach((order: any) => {
      this.totalDelivery += order.finalCost ?? 0;
      this.totalCommission += order.qtComisionCadete ?? 0;
      this.totalLiq += order.liquidacion ?? 0;
      this.neto += order.finalCost ?? 0;
    });
    
    // Redondear todos los totales a 2 decimales
    this.totalDelivery = Number(this.totalDelivery.toFixed(2));
    this.totalCommission = Number(this.totalCommission.toFixed(2));
    this.totalLiq = Number(this.totalLiq.toFixed(2));
    this.neto = Number(this.neto.toFixed(2));
  }

  constructor(
    public deliveryService: DeliveryService,
    public deliveryPayingService: DeliveryPayingService,
    public orderService: OrderService,
    public adminService: AdminService,
    public authService: AuthService,
    public particularOrderService: ParticularOrderService,
    private fb: FormBuilder,
    private snackBar: SnackBarService
  ) { }

  private toArray<T>(response: any): T[] {
    if (Array.isArray(response)) {
      return response;
    }

    const candidates = [response?.data, response?.items, response?.result, response?.values];
    const firstArray = candidates.find(Array.isArray);

    return firstArray ?? [];
  }

  ngOnInit() {
    this.deliveryService.apiDeliveryGetAllGet().subscribe(response => {
      console.log('Cadetes cargados:', response);
      this.allDeliveries = this.toArray<DeliveryOutputDto>(response);
    }, error => {
      console.error('Error al cargar cadetes', error);
    });

    // Limpiar datos cuando cambia el cadete seleccionado
    this.cadetesForm.get('cadete')?.valueChanges.subscribe(() => {
      this.clearOrdersData();
    });
  }

  /** Limpia los datos de órdenes y totales */
  private clearOrdersData() {
    this.dataSource.data = [];
    this.selection.clear();
    this.ordersList = [];
    this.totalDelivery = 0;
    this.totalCommission = 0;
    this.totalLiq = 0;
    this.neto = 0;
    this.totalReceipts = 0;
  }

  inpuDateFrom(event: any) {
    this.dateFrom = event.value;
    this.clearOrdersData();
  }

  inpuDateTo(event: any) {
    this.dateTo = event.value;
    this.clearOrdersData();
  }

  search(form: any) {
    // Limpiar totales y listas
    this.ordersList = [];
    this.totalDelivery = 0;
    this.totalCommission = 0;
    this.totalLiq = 0;
    this.neto = 0;
    this.totalReceipts = 0;
    this.dataSource.data = [];
    this.selection.clear();

    // Log de parámetros enviados
    console.log('Filtrando con:', {
      cadete: form.cadete,
      dateFrom: this.dateFrom,
      dateTo: this.dateTo,
      number: form.number
    });

    let dateFrom = this.dateFrom ? moment(this.dateFrom).startOf('day').toDate() : undefined;
    let dateTo = this.dateTo ? moment(this.dateTo).endOf('day').toDate() : undefined;

    // Usar HTTP client directamente para el nuevo endpoint
    // Primer paso: obtener IDs de órdenes
    const getIdsUrl = `${this.particularOrderService['basePath']}/api/ParticularOrder/GetParticularOrderIdsByDeliveryAndDate`;
    let params: any = { cdDelivery: form.cadete };
    if (dateFrom) params.dtFrom = dateFrom.toISOString();
    if (dateTo) params.dtTo = dateTo.toISOString();

    this.particularOrderService['httpClient'].get<number[] | any>(getIdsUrl, { params }).subscribe((response: number[] | any) => {
      const orderIds = this.toArray<number>(response);
      console.log('IDs de órdenes recibidos:', orderIds);
      
      if (orderIds && orderIds.length > 0) {
        // Segundo paso: calcular liquidación con los IDs obtenidos
        const calculateUrl = `${this.deliveryPayingService['basePath']}/api/DeliveryPaying/CalculateParticularOrderLiquidation`;
        let calcParams: any = {
          cdDelivery: form.cadete.toString()
        };
        
        // Agregar cada ID como parámetro separado para el array
        orderIds.forEach((id, index) => {
          calcParams[`listCdParticularOrder[${index}]`] = id.toString();
        });

        this.deliveryPayingService['httpClient'].get<any>(calculateUrl, { params: calcParams }).subscribe((liquidationData: any) => {
          console.log('Datos de liquidación calculados:', liquidationData);
          
          // Mapear los datos recibidos
          const orders: any[] = [];
          
          if (liquidationData?.orders?.length > 0) {
            liquidationData.orders.forEach((order: any) => {
              const mappedOrder = {
                cdOrder: order.cdOrder,
                dtCreatedAt: order.dtCreatedAt,
                dsName: order.dsName,
                calculatedCost: Number((order.calculatedCost ?? 0).toFixed(2)),
                finalCost: Number((order.finalCost ?? 0).toFixed(2)),
                finalCostWithIVA: order.finalCostWithIVA,
                qtComisionCadete: Number((order.qtComisionCadete ?? 0).toFixed(2)),
                liquidacion: Number((order.liquidacion ?? 0).toFixed(2)),
                cdDelivery: liquidationData.cdDelivery,
                commision: liquidationData.commision
              };
              orders.push(mappedOrder);
            });
          }
          
          this.dataSource.data = orders;

          // Usar los totales calculados por el backend
          if (liquidationData.totals) {
            this.totalDelivery = Number((liquidationData.totals.totalDelivery ?? 0).toFixed(2));
            this.totalCommission = Number((liquidationData.totals.totalCommission ?? 0).toFixed(2));
            this.totalLiq = Number((liquidationData.totals.totalLiq ?? 0).toFixed(2));
            this.neto = Number((liquidationData.totals.neto ?? 0).toFixed(2));
            this.totalReceipts = liquidationData.totals.totalReceipts ?? 0;
          } else {
            // Fallback: recalcular totales localmente
            this.recalculateTotals();
          }

          // Actualizar la lista de órdenes con todas las órdenes cargadas
          this.ordersList = this.dataSource.data.map(order => order.cdOrder);
        }, (error: any) => {
          this.snackBar.openSnackBar('Error al calcular la liquidación', 'Aceptar');
        });
      } else {
        this.snackBar.openSnackBar('No se encontraron órdenes para los criterios especificados', 'Aceptar');
      }
    }, (error: any) => {
      this.snackBar.openSnackBar('Error al obtener las órdenes', 'Aceptar');
    });
  }

  confirmLiquidation() {
    this.currentUser = this.authService.currentUser();
    
    // Usar solo las órdenes seleccionadas
    this.ordersList = this.selection.selected.map(order => order.cdOrder);
    
    // Validar que hay órdenes seleccionadas
    if (this.ordersList.length === 0) {
      this.snackBar.openSnackBar('No hay órdenes seleccionadas. Por favor, selecciona al menos una orden para liquidar.', 'Aceptar');
      return;
    }
    
    // Recalcular totales basados en las órdenes seleccionadas
    this.recalculateTotals();

    const confirmData: AdminRequestDto = {
      dsPassword: this.password,
      dsUsername: this.currentUser.dsUsername!
    };
    this.adminService.apiAdminConfirmPost(confirmData).subscribe(response => {
      let today = moment().toDate();
      
      // Nuevo formato del payload según la API actualizada
      this.deliveryPayingInput = {
        cdDelivery: this.cadetesForm.get('cadete')!.value,
        qtNeto: this.neto,
        qtComission: this.totalCommission,
        qtPaying: this.totalLiq,
        qtReceipt: this.totalReceipts,
        qtTotal: (this.neto + this.totalDelivery),
        dsObservation: this.observaciones,
        dtFecha: today,
        listCdOrder: [], // Array vacío para órdenes regulares
        listCdParticularOrder: this.ordersList // IDs de órdenes particulares seleccionadas
      };
      
      console.log('Enviando liquidación:', this.deliveryPayingInput);
      
      this.deliveryPayingService.apiDeliveryPayingPostParticularOrdersLiquidationPost(this.deliveryPayingInput).subscribe(response => {
        this.snackBar.openSnackBar('Liquidación emitida con éxito.', 'Aceptar');
        // Limpiar totales y tabla
        this.dataSource.data = [];
        this.ordersList = [];
        this.totalDelivery = 0;
        this.totalCommission = 0;
        this.totalLiq = 0;
        this.neto = 0;
        this.totalReceipts = 0;
        this.selection.clear();
      }, error => {
        this.snackBar.openSnackBar(error.error?.error || 'Error al procesar la liquidación', 'Aceptar');
      });
    }, error => {
      this.snackBar.openSnackBar('La contraseña es incorrecta.', 'Aceptar');
    });
  }
}
